import { MutationStatus } from '@tanstack/react-query';

import { UnsavedChangesStatus } from '../models';

// PURE LOGIC
export const getUnsavedStatus = (params: {
  saveStatus: MutationStatus;
  hasUnsavedChanges: boolean;
  remainingCharacters: number;
}): UnsavedChangesStatus => {
  const { saveStatus, hasUnsavedChanges, remainingCharacters } = params;

  const isCharacterLimitExceeded = remainingCharacters < 0;
  const isSaving = saveStatus === 'pending';
  const isSaveError = saveStatus === 'error';

  if (isCharacterLimitExceeded || isSaveError) {
    return 'error';
  }
  if (isSaving) {
    return 'saving';
  }
  if (hasUnsavedChanges) {
    return 'unsaved';
  }
  return null;
};

export const canSave = (status: UnsavedChangesStatus) => status !== 'error' && status !== null;

// HOOK
export const useUnsavedChangesStatus = (params: {
  saveStatus: MutationStatus;
  hasUnsavedChanges: boolean;
  remainingCharacters: number;
}) => {
  const status = getUnsavedStatus(params);

  const isSaving = params.saveStatus === 'pending';
  const hasError = status === 'error';

  return { status, isSaving, hasError, canSave: canSave(status) };
};
